/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { ZZZCharacter } from '../components/zzz-character';
import {
  faHandFist,
  faGavel,
  faFlask
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row, Col } from 'react-bootstrap';
import { YoutubeEmbed } from '../../../common/components/youtube-embed';

interface IProps {
  name: string;
  slug: string;
  character_element: string;
}

export const ZZZProfileTeams: React.FC<IProps> = ({
  slug,
  character_element
}) => {
  return (
    <>
      {slug === 'astra-yao' && (
        <>
          <p>
            Astra Yao's best with everyone (pretty much). As the easiest,
            quickest, and most universal Support unit in the game, she is able
            to slot as the best Support option to almost any team in the current
            Zenless Zone Zero meta, including all the best Agents, and being at
            least very very strong anywhere. Have fun using her as the best
            Support to just about anybody! (Or second best to Nicole, in very
            specific cases). Below are some examples of the top meta teams for
            you to take inspiration from:{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Miyabi Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Evelyn Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>ASanby Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>For more team ideas, check this video:</p>
          <Row className="video">
            <Col xs={12} lg={6}>
              <YoutubeEmbed embedId="nMcU-q0K4iw" />
            </Col>
          </Row>
        </>
      )}
      {slug === 'anby-demara' && (
        <>
          <p>
            Anby doesn't provide much utility to a team beyond providing a lot
            of Daze, dealing some damage, applying some Shock and activating
            certain Additional Abilities. As a result, she presents herself as a
            generalist F2P option for teams who need a Stun character
            (especially one that uses a lot of field time/applies Shock). Anby
            has many viable teams as a result (even though she is not optimal in
            any of them). Some of the teams she best fits in include:{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Double Anby Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Zhu Yuan Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="zhu-yuan"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Harumasa Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="harumasa"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Cunning Hare Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nekomata"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="billy-kid"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'anby-demara-soldier-0' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Double Support Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Knightboo</strong> = Extra Energy (Event Locked),
            </li>
            <li>
              <strong>Butlerboo</strong> = Extra Energy,
            </li>
            <li>
              <strong>Plugboo/Electroboo</strong> = When playing with Qingyi
            </li>
            <li>
              <strong>Brawlerboo</strong> = Attack Agent Synergy.
            </li>
          </ul>
          <p>For more team ideas, check this video:</p>
          <Row className="video">
            <Col xs={12} lg={6}>
              <YoutubeEmbed embedId="rH7gqoBWhAg" />
            </Col>
          </Row>
        </>
      )}
      {slug === 'anton' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anton"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Qingyi Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anton"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Anton & Grace Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anton"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="grace-howard"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Plugboo</strong> or <strong>Electroboo</strong> - since
              you're always playing with 2x Electric characters.
            </li>
          </ul>
        </>
      )}
      {slug === 'ben' && (
        <>
          <p>
            It should be noted that while Ben is a serviceable character,
            stronger Support alternatives to him should be present on your
            account (such as Lucy). We only recommend using Ben if you lack any
            other options or strongly like the character (he will still perform,
            but it'll take more effort out of you).{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> DPS / Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ben"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Koleda Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="koleda"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun / Sub-DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ben"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Rocketboo</strong> - since you're always playing with 2x
              Fire characters.
            </li>
          </ul>
        </>
      )}
      {slug === 'billy-kid' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Traditional Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="billy-kid"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            Make sure one of your teammates is Caesar or Nicole to activate
            Billy's Additional Ability!{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="billy-kid"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'burnice' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Classic Anomaly Team</p>
            </div>
            <div className="single-team with-comment">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>RocketBoo/Cryboo</strong> = If 2x Fire or nothing else
              below applies,
            </li>
            <li>
              <strong>Bangvolver</strong> = If 2x Physical,
            </li>
            <li>
              <strong>Red Moccus</strong> = Alternative if 2x Sons of Calydon,
            </li>
            <li>
              <strong>NEPS</strong> = Alternative if 2x NEPS members.
            </li>
          </ul>
        </>
      )}
      {slug === 'caesar' && (
        <>
          <p>
            Caesar is a very flexible Support unit that is excellent in teams
            that need her extra Daze, in the teams of players that want her
            shields, and in a broader sense, any team that wants her generalist
            ATK buffs and extra DMG mark (so any team at all). She is however
            outclassed by certain options in pure support (such as Astra Yao,
            Trigger, Nicole, Lucy in specific teams). But if you want her extra
            survivability, then she can slot anywhere as an extremely strong
            Support! Here are some example teams where she's especially
            desirable (but note that she can slot in any team's Support slot):{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>SAnby Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support / Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Ellen Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support / Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Corin/Billy Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="corin"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="billy-kid"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support / Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'corin' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="corin"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Caesar Double Support Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="corin"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="corin"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Butler</strong> = Victoria Housekeeping,
            </li>
            <li>
              <strong>Bangvolver</strong> or <strong>Bagboo</strong> = Physical
              Comps.
            </li>
          </ul>
        </>
      )}
      {slug === 'ellen' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Ellen Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Alternative Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Ellen Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Butler</strong> = 2x Victoria Housekeeping,
            </li>
            <li>
              <strong>Sharkboo</strong> or <strong>Penguinboo</strong> = 2x Ice.
            </li>
          </ul>
        </>
      )}
      {slug === 'evelyn' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Alternative Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Flex
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="koleda"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options (Bangboo will be determined by your core team):</p>
          <ul>
            <li>
              <strong>Snap</strong> = with Astra Yao,
            </li>
            <li>
              <strong>Rocketboo or Cryboo</strong> = for Fire teams,
            </li>
            <li>
              <strong>Brawlerboo</strong> = Generic option.
            </li>
          </ul>
          <p>For more team ideas, check this video:</p>
          <Row className="video">
            <Col xs={12} lg={6}>
              <YoutubeEmbed embedId="GmP1E9y7Vv8" />
            </Col>
          </Row>
        </>
      )}
      {slug === 'grace-howard' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="grace-howard"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Rina and Seth can also be used in the Support slot.</p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anton"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="grace-howard"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Plugboo</strong> or <strong>Electroboo</strong> - since
              you're always playing with 2x Electric characters.
            </li>
          </ul>
        </>
      )}
      {slug === 'harumasa' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="harumasa"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="harumasa"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Plugboo</strong> or <strong>Electroboo</strong> - if 2x
              Electric.
            </li>
          </ul>
        </>
      )}
      {slug === 'jane-doe' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Trigger Hypercarry Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="seth"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="seth"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="grace-howard"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Plugboo</strong> or <strong>Electroboo</strong> = If 2x
              Electric,
            </li>
            <li>
              <strong>Red Moccus</strong> = Alternative if 2x Sons of Calydon,
            </li>
          </ul>
        </>
      )}
      {slug === 'koleda' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="koleda"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'lighter' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team with-comment">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Miyabi/Ellen Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Ellen Double Stun Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'lucy' && (
        <>
          <p>
            Lucy is a generalist Support comparable to Nicole that holds a
            specific niche where she stands out from her (as she's typically
            overshadowed by her). Lucy stands out in teams that want her
            extremely low field time, her Fire Anomaly application, her high
            buff uptime, and her specific synergies. In general, these factors
            also make her significantly easier to fully exploit than Nicole, but
            Nicole can take a lot of teams to heights Lucy can't reach (while
            being comparable at a baseline). Below are some teams where she's
            most effective, but note she will work fine anywhere as a generalist
            Support.{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Evelyn Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="koleda"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Sub-DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Miyabi Hyper Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Burnice Disorder</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Sub-DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>RocketBoo/Cryboo</strong> = If 2x Fire,
            </li>
            <li>
              <strong>Red Moccus</strong> = Alternative if 2x Sons of Calydon.
            </li>
          </ul>
        </>
      )}
      {slug === 'lycaon' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Ellen Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Corin Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="corin"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'miyabi' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Yanagi Quick Swap Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support / Stun
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Double Support Team</p>
            </div>
            <div className="single-team with-comment">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Offield Anomaly</p>
            </div>
            <div className="single-team with-comment">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            ^ Depending on your Miyabi's investment, the enemy's weaknesses, the
            game mode or simply what you're comfortable with, any of these teams
            can be stronger than one another — you can use them interchangeably!{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Hypercarry Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Hypercarry Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            Use Lucy if Piper is involved, else use Soukaku (for Piper's
            Additional Ability!){' '}
          </p>
        </>
      )}
      {slug === 'nekomata' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nekomata"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>
            Make sure to only use Trigger with Nicole to activate Nekomata's
            Additional Ability!{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nekomata"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'nicole-demara' && (
        <>
          <p>
            Nicole is the definition of a generalist Support. She is able to
            slot as a support into any team as a top F2P option and, a majority
            of the time, the #2 best option period. (Sometimes along with
            Trigger in teams where she heavily benefits). Astra Yao outshines
            her as the sole Support in a majority of teams, but the pair work
            fantastically together making for great Hypercarry compositions.
            Here are some examples of the 2 kinds of teams she fits in
            especially well:{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Generic Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character empty">
                    Any DPS except Grace/Burnice/Piper
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Zhu Yuan/Harumasa Stun Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="zhu-yuan"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="harumasa"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Cunning Hare Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nekomata"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="billy-kid"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'qingyi' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="zhu-yuan"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Harumasa Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="harumasa"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>SAnby Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'piper' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivan"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivan"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Disorder Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="koleda"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Flex
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'pulchra' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Nekomata Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nekomata"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Soldier 11 Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Corin Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="corin"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>For more team ideas, check this video:</p>
          <Row className="video ">
            <Col xs={12} lg={6}>
              <YoutubeEmbed embedId="KO74F0eiYY4" />
            </Col>
          </Row>
        </>
      )}
      {slug === 'rina' && (
        <>
          <p>
            Rina can be used as a generalist Support to all teams that can
            appreciate her PEN Ratio boost (especially characters who can stack
            a lot of PEN) and shines especially in teams that appreciate her
            Shock application and buffs. You can use her in many teams, but
            teams where she's especially useful include:{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Miyabi Quick Swap</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Yanagi/Jane Doe Carry Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Harumasa Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="harumasa"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'seth' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Jane Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS / Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="seth"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Yanagi Anomaly Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="seth"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'soldier-11' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun / Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Double Support Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun / Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Stun / Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main ">
                    <ZZZCharacter
                      mode="icon"
                      slug="soldier-11"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="koleda"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="pulchra"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'trigger' && (
        <>
          <p>
            Trigger is a Stun Agent who not only brings a lot of off-field
            damage and Daze, but also provides a lot of buffs, and even DEF
            shred (similarly to Nicole) when she's using her signature W-Engine.
            As a result, she doubles not only as an amazing Stun unit, but also
            a Support. This means she's usable anywhere where her Stun is
            desirable. This includes a lot of top meta teams, but below are some
            of the best ones:{' '}
          </p>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara-soldier-0"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Yanagi Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Miyabi Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Evelyn Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="evelyn"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>Pick a Bangboo based on the main DPS you use.</li>
          </ul>
          <p>For more team ideas, check this video:</p>
          <Row className="video">
            <Col xs={12} lg={6}>
              <YoutubeEmbed embedId="voe98pokU8I" />
            </Col>
          </Row>
        </>
      )}
      {slug === 'vivian' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Sub-DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Tripple Anomaly Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi-equal">
                    <ZZZCharacter
                      mode="icon"
                      slug="jane-doe"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Sub-DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Sub-DPS
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="vivian"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> Sub-DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>[Robin]</strong> - For extra Ether Anomaly Buildup
              (Recommended)
            </li>
            <li>
              <strong>[Snap]</strong> - General Extra Damage alternative
            </li>
            <li>
              <strong>[Luckyboo]</strong> - Alternative for Jane teams
            </li>
          </ul>
          <p>For more team ideas, check this video:</p>
          <Row className="video">
            <Col xs={12} lg={6}>
              <YoutubeEmbed embedId="u7NdRKzQgvw" />
            </Col>
          </Row>
        </>
      )}
      {slug === 'soukaku' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="lighter"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lycaon"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Miyabi Disorder F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="piper"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Ellen Double Support F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="ellen"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="soukaku"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {slug === 'yanagi' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="miyabi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Trigger Hypercarry Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="trigger"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Burnice Disorder Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="burnice"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role sub-dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> SUB DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="caesar"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Double Support Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="yanagi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="rina"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="grace-howard"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                    <ZZZCharacter
                      mode="icon"
                      slug="lucy"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Agent Gulliver</strong> = Strong choice if there are at
              least two Section 6 characters in the team,
            </li>
            <li>
              <strong>Plugboo/Electrobo</strong> = If 2x Electric
              (Seth/Rina/Qingyi/Anby),
            </li>
            <li>
              <strong>RocketBoo/Cryboo</strong> = If 2x Fire
              (Koleda/Lucy/Burnice),
            </li>
            <li>
              <strong>Bangvolver</strong> = If 2x Physical (Piper/Jane/Caesar).
            </li>
          </ul>
        </>
      )}
      {slug === 'zhu-yuan' && (
        <>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Best Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="zhu-yuan"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="qingyi"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>Mono Ether Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="zhu-yuan"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main multi">
                    <ZZZCharacter
                      mode="icon"
                      slug="astra-yao"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`character-teams box ${character_element}`}>
            <div className="team-header">
              <p>F2P Team</p>
            </div>
            <div className="single-team">
              <div className="team-row">
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="zhu-yuan"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role dps">
                    <FontAwesomeIcon icon={faHandFist} width="18" /> DPS
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="anby-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role stun">
                    <FontAwesomeIcon icon={faGavel} width="18" /> Stun
                  </div>
                </div>
                <div className="with-role">
                  <div className="character main">
                    <ZZZCharacter
                      mode="icon"
                      slug="nicole-demara"
                      enablePopover
                      showLabel
                    />
                  </div>
                  <div className="role support">
                    <FontAwesomeIcon icon={faFlask} width="18" /> Support
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p>Bangboo options:</p>
          <ul>
            <li>
              <strong>Reasonaboo</strong> = Great for grouping enemies,
            </li>
            <li>
              <strong>Officer Cui</strong> = Gives more damage,
            </li>
            <li>
              <strong>Devilboo</strong> or <strong>Bagboo</strong> = F2P
              alternatives.
            </li>
          </ul>
        </>
      )}
    </>
  );
};
